import { render } from "./ExhibitionPage.vue?vue&type=template&id=346e717a&scoped=true"
import script from "./ExhibitionPage.vue?vue&type=script&lang=js"
export * from "./ExhibitionPage.vue?vue&type=script&lang=js"

import "./ExhibitionPage.vue?vue&type=style&index=0&id=346e717a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346e717a"]])

export default __exports__